if (!customElements.get('fable-ugc-grid')) {
  customElements.define(
    'fable-ugc-grid',
    class FableUgcGrid extends HTMLElement {
      connectedCallback() {
        this.tiles = this.querySelector('[data-tiles]');
        this.more = this.querySelector('[data-load-more]');
        this.step = Math.max(parseInt(this.dataset.step, 10) || 1, 1);
        this.isCarousel = this.classList.contains('fable-ugc--mobile-carousel');
        this.mobile = window.matchMedia('(max-width: 799px)');
        this.noHover = window.matchMedia('(hover: none)');

        this.onMore = this.onMore.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onViewport = this.onViewport.bind(this);
        this.onTap = this.onTap.bind(this);

        if (this.more) this.more.addEventListener('click', this.onMore);
        this.addEventListener('click', this.onTap);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        if (this.mobile.addEventListener) this.mobile.addEventListener('change', this.onViewport);
        this.onViewport();
      }

      disconnectedCallback() {
        if (this.more) this.more.removeEventListener('click', this.onMore);
        this.removeEventListener('click', this.onTap);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.mobile && this.mobile.removeEventListener) this.mobile.removeEventListener('change', this.onViewport);
      }

      get hiddenGroups() {
        return Array.from(this.querySelectorAll('[data-group][hidden]'));
      }

      /* tiles whose caption is hidden at rest from 800px and that hold nothing focusable */
      get captionTiles() {
        return Array.from(this.querySelectorAll('[data-tile]')).filter(
          (tile) => tile.querySelector('.fable-ugc__caption') && !tile.querySelector('a[href]')
        );
      }

      /* the swipeable row is a scroll container: make it reachable from the keyboard.
         From 800px the captions are hidden at rest, so their tiles become tab stops instead. */
      onViewport() {
        if (!this.tiles) return;
        const small = this.mobile.matches;
        this.captionTiles.forEach((tile) => {
          if (small) {
            if (tile.getAttribute('tabindex') === '0') tile.removeAttribute('tabindex');
            tile.classList.remove('is-revealed');
          } else {
            tile.setAttribute('tabindex', '0');
          }
        });
        if (this.isCarousel && this.mobile.matches) {
          this.tiles.setAttribute('tabindex', '0');
          this.tiles.setAttribute('role', 'group');
          if (this.tiles.dataset.labelledby) this.tiles.setAttribute('aria-labelledby', this.tiles.dataset.labelledby);
        } else {
          this.tiles.removeAttribute('tabindex');
          this.tiles.removeAttribute('role');
          this.tiles.removeAttribute('aria-labelledby');
        }
      }

      reveal(groups) {
        groups.forEach((group) => group.removeAttribute('hidden'));
        if (this.more && !this.hiddenGroups.length) {
          this.more.removeEventListener('click', this.onMore);
          this.more.remove();
          this.more = null;
        }
      }

      onMore() {
        const groups = this.hiddenGroups.slice(0, this.step);
        if (!groups.length) return;
        const first = groups[0];
        this.reveal(groups);

        /* hand focus to the first new tile so keyboard and screen reader users continue from there */
        const target = first.querySelector('a[href]') || first.querySelector('[data-tile]');
        if (!target) return;
        if (!target.matches('a[href]') && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }

      /* screens that cannot hover: a tap shows that tile's caption, a second tap or a tap on another tile hides it */
      onTap(event) {
        if (this.mobile.matches || !this.noHover.matches) return;
        const tile = event.target.closest('[data-tile]');
        if (event.target.closest('a[href]')) return;
        this.querySelectorAll('[data-tile].is-revealed').forEach((other) => {
          if (other !== tile) other.classList.remove('is-revealed');
        });
        this.classList.add('is-touched');
        if (tile && tile.querySelector('.fable-ugc__caption')) tile.classList.toggle('is-revealed');
      }

      onBlockSelect(event) {
        const tile = event.target.closest('[data-tile]');
        if (!tile) return;
        const group = tile.closest('[data-group]');
        if (group && group.hidden) this.reveal([group]);
        if (this.isCarousel && this.mobile.matches) {
          tile.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      }
    }
  );
}
